import { Injectable } from '@angular/core';
import { UtilService, LocalStorageService, NameValue } from '../../shared/index';
import { ProfileSearchComponentModel } from '../search/profile-search-component.model';
import { ProfileSearchLoadOptionsDto } from './dto/profile-search-load-options.dto';

@Injectable()
export class ProfileSearchParameterService {
  private _paramNameSearchResults = 'profileSearchResults';
  private _paramNameV2SearchResults = 'profileSearchV2Results';
  private _paramNameSearchLoadOptions = 'profileSearchLoadOptions';

  constructor(private _localStorageService: LocalStorageService) {
    const version = window['wlVersion'];
    this._paramNameSearchResults += version;
    this._paramNameSearchLoadOptions += version;
  }

  hasResults(): boolean {
    return this._localStorageService.hasItem(this._paramNameSearchResults);
  }

  hasProfileSearchResults() {
    return this._localStorageService.hasItem(this._paramNameSearchResults);
  }

  getProfileSearchResults(): ProfileSearchComponentModel {
    if (this._localStorageService.hasItem(this._paramNameSearchResults)) {
      return this._localStorageService.getObject(this._paramNameSearchResults);
    }
  }

  setProfileSearchResults(params: ProfileSearchComponentModel) {
    this._localStorageService.setObject(this._paramNameSearchResults, params);
  }

  clearProfileSearchResults() {
    if (this._localStorageService.hasItem(this._paramNameSearchResults)) {
      this._localStorageService.removeItem(this._paramNameSearchResults);
    }
  }

  getSearchLoadOptions(): ProfileSearchLoadOptionsDto {
    if (this._localStorageService.hasItem(this._paramNameSearchLoadOptions)) {
      return this._localStorageService.getObject(this._paramNameSearchLoadOptions);
    }
    return null;
  }

  setSearchLoadOptions(options: ProfileSearchLoadOptionsDto) {
    this._localStorageService.setObject(this._paramNameSearchLoadOptions, options);
  }

  clearSearchLoadOptions() {
    if (this._localStorageService.hasItem(this._paramNameSearchLoadOptions)) {
      this._localStorageService.removeItem(this._paramNameSearchLoadOptions);
    }
  }
}
